<template>

    <div id="my-quizzes-edit-game">

        <section class="heading-section" data-aos="fade-in">
            <div class="row mx-xl-4 py-2">
                <div class="col-4 heading">
                    <a href="/my-quizzes" class="back"></a>
                    <div class="title">{{ t.__('Edytuj quiz') }}</div>
                </div>
                <div class="col-8 text-right">
                    <my-quizzes-legend></my-quizzes-legend>
                </div>
            </div>
            <div class="mx-xl-5 buttons">
                <div class="search-field">
                    <input type="text" :placeholder="t.__('Wyszukaj')" v-model="filterInput" @input="applyFilter">
                </div>
            </div>
        </section>

        <section class="game-data-section mx-xl-4 mt-2">

            <div class="display-data" v-if="!gameDataEditState">
                <div class="name-column">
                    <div class="icon"
                         :style="form.icon !== null && form.icon.url !== null ? {'background-image': 'url(' + form.icon.url + ')'} : {'background': '#000000'}"></div>
                    <div class="text">{{ game.display_name }}</div>
                </div>
                <div class="description-column">{{ game.display_description }}</div>
                <div class="mechanism-column">
                    <div class="mechanism-icon" :class="game.mechanism"></div>
                    <div class="text">{{ t.__('Wybrana gra') }}: {{ mechanismName }}</div>
                </div>
                <div class="edit-btn" @click="gameDataEditState = true"></div>
            </div>

            <div class="edit-data" v-if="gameDataEditState">
                <div class="icon-column">
                    <div class="form-group">
                        <legend>{{ t.__('Ikona') }}</legend>
                        <file-manager-image-select :input-name="'icon'" :value="form.icon" v-model="form.icon"
                                                   :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'"
                                                   :crop-available="true" :crop-aspect-ratio="240/320"
                                                   :width="300"></file-manager-image-select>
                    </div>
                </div>
                <div class="form-column">
                    <b-form-group
                        id="my-quizzes-edit-game-display-name-group"
                        description=""
                        :label="t.__('Nazwa wyświetlana')"
                        label-for="my-quizzes-aedit-game-display-name"
                        valid-feedback=""
                        :invalid-feedback="form.errors.get('display_name')"
                        :state="form.errors.state('display_name')"
                        :disabled="processing">
                        <b-form-input id="my-quizzes-edit-game-display-name" v-model="form.display_name"
                                      :state="form.errors.state('display_name')" trim></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="my-quizzes-edit-game-display-description-group"
                        description=""
                        :label="t.__('Opis wyświetlany (max. 200 znaków)')"
                        label-for="my-quizzes-edit-game-description-name"
                        valid-feedback=""
                        :invalid-feedback="form.errors.get('display_description')"
                        :state="form.errors.state('display_description')"
                        :disabled="processing">
                        <b-form-textarea id="my-quizzes-edit-game-display-description"
                                         v-model="form.display_description" max="200"
                                         :state="form.errors.state('display_description')" trim></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="info-column">
                    <div class="mechanism-row">
                        <div class="mechanism-icon" :class="game.mechanism"></div>
                        <div class="text">{{ t.__('Wybrana gra') }}: {{ mechanismName }}</div>
                    </div>
                    <div class="info-row">
                        <div class="square"></div>
                        <div class="text">{{ t.__('Liczba kategorii') }}: {{ categories.length }}</div>
                    </div>
                    <div class="info-row">
                        <div class="square"></div>
                        <div class="text">{{ t.__('Kolejność pytań: losowa') }}</div>
                    </div>
                    <div class="info-row">
                        <div class="square"></div>
                        <div class="text">{{ t.__('Data ostatniej edycji') }}:
                            {{ lastEditDate !== null ? lastEditDate : '---' }}
                        </div>
                    </div>
                </div>
                <div class="close-btn" @click="gameDataEditState = false"></div>
            </div>

        </section>

        <section class="buttons-section mx-xl-4 mt-3">
            <div class="category-button-wrapper" v-if="['ships', 'carousel'].includes(game.mechanism)"
                 v-for="(category, index) in form.categories" :key="category.identifier">
                <div class="category-button" :class="{active: activeCategory === category.identifier}"
                     @click="showCategory(category.identifier)">
                    <div class="icon"
                         :style="category.icon !== null && category.icon.url !== null ? {'background-image': 'url(' + category.icon.url + ')', 'background-size': 'cover'} : {}"></div>
                    <div class="name">{{ category.display_name }}</div>
                    <div class="edit-btn" @click="editCategory(category)"></div>
                </div>
                <my-quizzes-category-hint v-if="index === 0"></my-quizzes-category-hint>
            </div>
            <div class="button-delete" @click="removeSelectedRows">
                <div class="name">{{ t.__('Usuń') }}</div>
                <div class="icon"></div>
            </div>
            <div class="import-csv-btn" @click="showImportCsvModal">
                <div class="icon"></div>
                <div class="text">{{ t.__('Importuj dane z pliku') }}</div>
            </div>
            <b-button variant="success" class="save-btn" @click="saveData" :disabled="processing"
                      v-text="processing ? t.__('Zapisuję...') : t.__('Zapisz')"></b-button>
        </section>

        <section class="grid-section mx-xl-4 mt-1 mb-1">

            <ag-grid-vue style="width: 100.06%;"
                         class="ag-theme-material"
                         :gridOptions="gridOptions"
                         @model-updated="onModelUpdated"
                         @row-drag-end="onRowDragEnd"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         v-model="rowData"
                         :suppressRowClickSelection="true"
                         :rowSelection="rowSelection"
                         :rowDragManaged="true"
                         :animateRows="true"
                         :domLayout="domLayout"
                         :overlayNoRowsTemplate="t.__('Brak wierszy do wyświetlenia')"
                         :getRowNodeId="getRowNodeId"
                         @grid-ready="gridReady">
            </ag-grid-vue>

            <div @click="addRow" class="add-row-btn">
                <div class="icon"></div>
                <div class="text">{{ t.__('Dodaj wiersz') }}</div>
            </div>

        </section>

        <my-quizzes-game-modal></my-quizzes-game-modal>

        <my-quizzes-game-category-modal></my-quizzes-game-category-modal>

        <my-quizzes-import-data-modal :columns="columnNames"
                                      @import="loadDataFromCsv($event)"></my-quizzes-import-data-modal>

        <my-quizzes-save-empty-fields-modal></my-quizzes-save-empty-fields-modal>

    </div>

</template>

<script>

import {AgGridVue} from 'ag-grid-vue';
import Image from '../file-manager/classes/Image';

export default {
    name: 'MyQuizzesEditGame',
    components: {AgGridVue},
    props: {game: Object, lastEditDate: String, categories: Array, editorConfig: Object},
    data() {
        return {
            eventHub: window.eventHub,
            gameDataEditState: false,
            processing: false,
            activeCategory: null,
            form: new Vue.prototype.Form({
                icon: null,
                display_name: null,
                display_description: null,
                categories: [],
            }),
            gridOptions: {
                immutableData: true,
                onCellEditingStarted: () => document.getElementsByClassName('ag-text-area-input')[0].select()
            },
            gridApi: null,
            gridColumnApi: null,
            defaultColDef: null,
            columnDefs: this.buildColumnDefs(),
            domLayout: 'autoHeight',
            rowData: null,
            rowSelection: 'multiple',
            filterInput: null,
            emptyFieldsConfirmed: false,
        };
    },
    watch: {
        rowData: {
            deep: true,
            handler(newVal) {
                let hasEmptyField = newVal.some(row => {
                    let isEmpty = false;
                    Object.keys(row).forEach(key => {
                        if (row[key] === '') {
                            isEmpty = true;
                        }
                    });
                    return isEmpty;
                });
                if (!hasEmptyField) {
                    this.emptyFieldsConfirmed = false;
                }
            }
        }
    },
    computed: {
        mechanismName() {
            switch (this.game.mechanism) {
                case 'assoc':
                    return t.__('Skojarzenia');
                case 'carousel':
                    return t.__('Karuzela pytań');
                case 'qball':
                    return  t.__('Piłka nożna - quiz')
                case 'ships':
                    return t.__('Statki');
                default:
                    return '';
            }
        },
        columnNames() {
            let columns = this.columnDefs.slice();
            columns.splice(0, 2);
            return columns.map(col => col.headerName);
        },
    },
    beforeMount() {
        this.form.setData(this.prepareFormInitialData());
        if (this.categories.length) this.showCategory(this.categories[0].identifier);
        this.listenToEvents();
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridColumnApi = this.gridOptions.columnApi;
    },
    methods: {
        buildColumnDefs() {
            const buildCommonCol = (header, field, maxLength = 1000) => ({
                headerName: header,
                field: field,
                resizable: true,
                sortable: true,
                filter: false,
                cellRenderer: param => (param.value !== undefined ? param.value.replace(/[\r\n]/g, '•') : param.value),
                editable: true,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorParams: {maxLength: maxLength, rows: 4, cols: 60},
            });

            let columnDefs = [
                {
                    headerName: '',
                    lockPosition: true,
                    cellClass: 'no-border',
                    width: 35,
                    suppressSizeToFit: true,
                    resizable: false,
                    suppressNavigable: true,
                    suppressCellSelection: true,
                    rowDrag: true,
                    valueGetter: params => params.data.question
                },
                {
                    headerName: '',
                    lockPosition: true,
                    cellClass: 'no-border',
                    width: 65,
                    suppressSizeToFit: true,
                    resizable: false,
                    suppressNavigable: true,
                    suppressCellSelection: true,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    checkboxSelection: true
                },
                buildCommonCol(t.__('Pytanie'), 'question'),
            ];

            if (this.editorConfig.hasOwnProperty('tips') && this.editorConfig.tips > 0) {
                for (let i = 1; i <= this.editorConfig.tips; i++) columnDefs.push(buildCommonCol(t.__('Podpowiedź') + ' ' + i, 'tip_' + i));
            }

            columnDefs.push(buildCommonCol(t.__('Poprawna odp.'), 'correct_answer'));

            if (this.editorConfig.hasOwnProperty('answers') && this.editorConfig.answers > 0) {
                for (let i = 1; i < this.editorConfig.answers; i++) columnDefs.push(buildCommonCol(t.__('Niepoprawna odp.') + ' ' + i, 'incorrect_answer_' + i));
            }

            return columnDefs;
        },
        prepareFormInitialData() {
            const prepareCategoryData = category => ({
                identifier: category.identifier,
                display_name: category.display_name || '',
                icon: new Image(category.icon_url),
                content: this.getPreparedContentData(category.content),
                content_columns: []
            });

            return {
                icon: new Image(this.game.icon_url),
                display_name: this.game.display_name,
                display_description: this.game.display_description,
                categories: this.categories.map(category => prepareCategoryData(category)),
            };
        },
        listenToEvents() {
            this.eventHub.$on('my-quizzes-update-edit-category', this.updateCategoryData);
            this.eventHub.$on('my-quizzes-edit-with-empty-fields-confirmed', () => {
                this.emptyFieldsConfirmed = true;
                this.saveData();
            });
        },
        updateCategoryData(categoryData) {
            let index = this.form.categories.findIndex(category => category.identifier === categoryData.identifier);
            if (index !== -1) {
                this.form.categories[index].icon = categoryData.icon;
                this.form.categories[index].display_name = categoryData.display_name;
            }
        },
        showImportCsvModal() {
            this.eventHub.$emit('my-quizzes-show-import-data-modal');
        },
        loadDataFromCsv(data) {
            this.rowData = this.getPreparedContentData(data);
        },
        showCategory(identifier) {
            let category = this.form.categories.find(c => c.identifier === identifier);
            if (category !== undefined) {
                this.copyCurrentCategoryContentToForm();
                this.activeCategory = identifier;
                this.rowData = category.content;
            }
        },
        copyCurrentCategoryContentToForm() {
            let index = this.form.categories.findIndex(c => c.identifier === this.activeCategory);
            if (index !== -1) {
                let categories = this.form.categories;
                categories[index].content = this.rowData;
                this.$set(this.form, 'categories', categories);
            }
        },
        getRowNodeId(data) {
            return data.id;
        },
        onModelUpdated() {
            if (this.gridOptions.api && this.columnDefs) this.gridOptions.api.sizeColumnsToFit();
        },
        onRowDragEnd() {
            let updatedRowData = [];
            this.gridOptions.api.forEachNode(node => updatedRowData.push(node.data));
            this.rowData = updatedRowData;
        },
        applyFilter() {
            this.gridOptions.api.setQuickFilter(this.filterInput);
        },
        removeSelectedRows() {
            let selectedRowData = this.gridApi.getSelectedRows();
            this.gridOptions.api.updateRowData({remove: selectedRowData});
        },
        editCategory(category) {
            this.eventHub.$emit('my-quizzes-game-edit-category', category);
        },
        addRow() {
            const createNewRow = () => {
                let newRow = {
                    id: Math.floor(new Date().valueOf() * Math.random()),
                    question: '',
                    correct_answer: ''
                };

                const addFields = (prefix, count) => {
                    for (let i = 1; i <= count; i++) newRow[prefix + i] = '';
                };

                if (this.editorConfig.hasOwnProperty('answers')) addFields('incorrect_answer_', this.editorConfig.answers - 1);
                if (this.editorConfig.hasOwnProperty('tips')) addFields('tip_', this.editorConfig.tips);

                return newRow;
            };

            this.gridOptions.api.applyTransaction({add: [createNewRow()]});
        },
        getPreparedContentData(data) {
            let newRowData = [];
            let columnDefs = this.columnDefs.slice(0); // clone array
            columnDefs.shift();
            columnDefs.shift();
            data.forEach((row) => {
                let newRowItem = {};
                let i = 0;
                columnDefs.forEach((colDef) => {
                    newRowItem[colDef.field] = (row[i] !== undefined) ? row[i] : ''; // Dodane sprawdzenie
                    i++;
                });
                newRowData.push(newRowItem);
            });
            newRowData.forEach((data, index) => {
                data.id = index;
            });
            return newRowData;
        },
        gridReady() {
            this.gridApi.sizeColumnsToFit();
        },
        saveData() {

            this.copyCurrentCategoryContentToForm();

            let categories = this.form.categories;
            let hasEmptyField = false;

            categories.map(category => {
                category.content.map(row => {
                    let data = [];
                    data.push(row.question || '');

                    if (this.editorConfig.hasOwnProperty('tips') && this.editorConfig.tips > 0) {
                        for (let i = 1; i <= this.editorConfig.tips; i++) {
                            data.push(row['tip_' + i] || '');
                            if (row['tip_' + i] === '') {
                                hasEmptyField = true;
                            }
                        }
                    }

                    data.push(row.correct_answer || '');
                    if (row.correct_answer === '') {
                        hasEmptyField = true;
                    }

                    if (this.editorConfig.hasOwnProperty('answers') && this.editorConfig.answers > 0) {
                        for (let i = 1; i < this.editorConfig.answers; i++) {
                            data.push(row['incorrect_answer_' + i] || '');
                            if (row['incorrect_answer_' + i] === '') {
                                hasEmptyField = true;
                            }
                        }
                    }

                    return data;
                });

                return category;
            });

            if (this.emptyFieldsConfirmed === false && hasEmptyField) {
                this.eventHub.$emit('my-quizzes-edit-with-empty-fields-confirm');
                return;
            }

            this.processing = true;
            this.$set(this.form, 'categories', categories);
            this.form.put('/my-quizzes/update-game/' + this.game.output_identification_name)
                .then(response => {
                    if (response.success) {
                        this.$set(this.game, 'display_name', this.form.display_name);
                        this.$set(this.game, 'display_description', this.form.display_description);
                        window.location.replace('/my-quizzes');
                    } else {
                        alert(t.__('Coś poszło nie tak'));
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.processing = false;
                });
        }

    }

}
</script>

<style scoped>

</style>
